export enum FacingDirection {
    FRONT = "FRONT",
    BACK = "BACK",
    LEFT = "LEFT",
    RIGHT = "RIGHT",
}

export const FacingDirectionToTranslationKey: Record<FacingDirection, string | null> = {
    [FacingDirection.FRONT]: "app.assessments.tabs.front",
    [FacingDirection.BACK]: "app.assessments.tabs.back",

    // These do not exist in the translation JSON
    [FacingDirection.LEFT]: null,
    [FacingDirection.RIGHT]: null,
};
